var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.iconName
    ? _c(
        "div",
        {
          staticClass:
            "display-flex flex-row flex-wrap flex-items-stretch icon-actions",
          staticStyle: {
            "--button-margin-bottom": "0",
            gap: "var(--spacing-md)",
          },
        },
        [
          _vm.gettingStartedURL
            ? _c(
                "site-link",
                {
                  class: _vm.startUsingActionClass,
                  style: _vm.actionStyle,
                  attrs: {
                    to: _vm.gettingStartedURL,
                    "aria-label": _vm.startUsingActionToolTip,
                    "data-balloon-pos": "up",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.getStartedLink.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.regular.faRocketLaunch,
                      "fixed-width": "",
                      size: "xl",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "margin-left-2xs" }, [
                    _vm._v(_vm._s(_vm.getStartedLabel)),
                  ]),
                ],
                1
              )
            : _c(
                "button",
                {
                  class: _vm.startUsingActionClass,
                  staticStyle: { "flex-grow": "1" },
                  style: _vm.actionStyle,
                  attrs: {
                    "aria-label": _vm.startUsingActionToolTip,
                    "data-balloon-pos": "up",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.getStarted.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.regular.faRocketLaunch,
                      "fixed-width": "",
                      size: "xl",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "margin-left-2xs" }, [
                    _vm._v(_vm._s(_vm.getStartedLabel)),
                  ]),
                ],
                1
              ),
          _vm._v(" "),
          _vm.editable
            ? _c(
                "button",
                {
                  staticClass: "position-relative icon-action-customize",
                  staticStyle: {
                    "flex-grow": "0",
                    "padding-right": "var(--spacing-md)",
                  },
                  style: _vm.actionStyle,
                  attrs: {
                    "aria-label": "Magically add modifiers to this icon!",
                    "data-balloon-pos": "up",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.editIcon()
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faSquareDashedCirclePlus,
                      "fixed-width": "",
                      size: "xl",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Add Modifiers with the Icon Wizard"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCustomIcon
            ? _c(
                "button",
                {
                  staticClass: "position-relative icon-action-svg-download",
                  style: _vm.actionStyle,
                  attrs: {
                    "aria-label": `Delete ${_vm.icon.name}`,
                    "data-balloon-pos": "up",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("showConfirmDelete")
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faTrashCan,
                      "fixed-width": "",
                      size: "lg",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Delete " + _vm._s(_vm.icon.name)),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }